import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Col, message, Radio, Row, Space, Spin } from 'antd'
import { CustomBottomAction, Typography } from 'modules/core/components'
import emptyImage from 'assets/images/compositions/empty-big.svg'
import reports from 'modules/reports'
import login from 'modules/login'
import _ from 'lodash'
import * as QuickSightEmbedding from 'amazon-quicksight-embedding-sdk'

import './ReportDashboards.scss'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { generateMessageError } from '../../../../../core/utils'
import home from '../../../../../home'
import DashboardSkeleton from '../../../../../home/containers/Home/components/DashboardSkeleton/DashboardSkeleton'

const getDashboard = (id, url) => {
  var dashboard
  const onDashboardLoad = (payload) => {
    console.log('Do something when the dashboard is fully loaded.')
  }

  const onError = (payload) => {
    console.log('Do something when the dashboard fails loading')
  }
  const embedDashboard = () => {
    var containerDiv = document.getElementById(id)
    var options = {
      url,
      container: containerDiv,
      parameters: {
        country: 'United States',
      },
      scrolling: 'no',
      iframeResizeOnSheetChange: true,
      height: 'AutoFit',
      loadingHeight: '700px',
      width: '100%',
    }
    dashboard = QuickSightEmbedding.embedDashboard(options)
    dashboard.on('error', onError)
    dashboard.on('load', onDashboardLoad)
    return dashboard
  }
  return embedDashboard
}

const ReportDashboards = ({
  fetchDashboardUrl,
  dashboardUrl = {},
  fetchEmbeddedByBi,
  resourcesByBi,
  createEmbeddedByBi,
  embeddedByBi,
}) => {
  const enabledRevamp = useFeatureIsOn('ab_revamp_quicksight')
  const [quickSightType, setQuickSightType] = useState('Analysis')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const [loadingIframe, setLoadingIframe] = useState(false)

  const [dataDashboard, setDataDashboard] = useState()

  useEffect(() => {
    if (!enabledRevamp) return

    setIsLoading(true)
    fetchEmbeddedByBi()
      .then(() => setIsLoading(false))
      .catch((error) => {
        setError(error.response.data)
        setIsLoading(false)
      })
  }, [enabledRevamp, fetchEmbeddedByBi])

  useEffect(() => {
    if (!enabledRevamp) return

    const firstResource = resourcesByBi[0]
    if (!_.isEmpty(firstResource)) {
      const firstKey = Object.keys(firstResource)[0]
      setQuickSightType(firstKey)
    }
  }, [enabledRevamp, resourcesByBi])

  useEffect(() => {
    const resource = searchBy(quickSightType)
    if (_.isEmpty(resource)) return

    const { resourceId, resourceType } = resource
    setLoadingIframe(true)
    createEmbeddedByBi({
      resource_id: resourceId ?? null,
      resource_type: resourceType ?? null,
    }).catch((error) => {
      message.error(generateMessageError(error), 8)
    })
  }, [createEmbeddedByBi, quickSightType])

  useEffect(() => {
    if (enabledRevamp) return

    setIsLoading(true)
    fetchDashboardUrl()
      .then(() => setIsLoading(false))
      .catch((error) => {
        setError(error.response.data)
        setIsLoading(false)
      })
  }, [fetchDashboardUrl])

  useEffect(() => {
    if (!isLoading && !enabledRevamp && !_.isEmpty(dashboardUrl)) {
      const dashboard = getDashboard('embeddingContainer', dashboardUrl.EmbedUrl)
      setDataDashboard(dashboard)
    }
  }, [dashboardUrl, isLoading])

  const resourceBy = () => {
    return resourcesByBi.flatMap((it) => Object.keys(it))
  }

  const searchBy = (type) => {
    return _.get(
      _.find(resourcesByBi, (it) => _.has(it, type)),
      type,
    )
  }

  const handleLoad = () => {
    console.log('Iframe loaded')
    setLoadingIframe(false)
  }

  const renderNotPermissionScreen = () => (
    <Space className="not-permission-screen" direction="vertical" size="large">
      <img alt="not-permission-screen" src={emptyImage} />
      <div>
        <Typography.Headline level={5} type="title">
          {/* {error} */}
          No tienes permisos
        </Typography.Headline>
      </div>
    </Space>
  )

  return (
    <Spin spinning={isLoading}>
      <Col span={24} style={{ height: 30 }}>
        {enabledRevamp && (
          <div style={{ float: 'left' }}>
            <Radio.Group
              options={resourceBy().map((it) => ({
                id: it,
                label: it,
                value: it,
              }))}
              onChange={(e) => setQuickSightType(e.target.value)}
              value={quickSightType}
              optionType="button"
              buttonStyle="solid"
              size={'small'}
            />
          </div>
        )}
        <div style={{ float: 'right' }}>
          <CustomBottomAction extraButtons={{ module_name: 'reportes', concept: '2' }} />
        </div>
      </Col>
      {enabledRevamp && (
        <div>
          {loadingIframe && <DashboardSkeleton />}
          <iframe
            id="DashboardhHome"
            title="DashboardhHome"
            src={embeddedByBi?.EmbedUrl}
            width="100%"
            height={window.innerHeight - 170}
            onLoad={handleLoad}
            style={{
              border: 'none',
              padding: '0 0',
              overflowX: 'hidden',
              overflowY: 'auto',
            }}
          ></iframe>
        </div>
      )}

      {!enabledRevamp && !isLoading && !error && !_.isEmpty(dashboardUrl) && (
        <div className="dashboard-container">
          <Row gutter={[8, 8]}>
            <Col span={24}>
              <div id="embeddingContainer"></div>
            </Col>
          </Row>
        </div>
      )}
      {!isLoading && error && renderNotPermissionScreen()}
    </Spin>
  )
}

const mapStateToProps = (state) => ({
  dashboardUrl: reports.selectors.getDashboardUrl(state),
  resourcesByBi: reports.selectors.getResourcesByBi(state),
  embeddedByBi: home.selectors.getDashboardQuicksight(state),
  loggedUser: login.selectors.getWhoAmI(state),
})

const mapDispatchToProps = {
  fetchDashboardUrl: reports.actions.fetchDashboardUrl,
  fetchEmbeddedByBi: reports.actions.fetchEmbeddedByBI,
  createEmbeddedByBi: home.actions.fetchEmbedQuicksightUrl,
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportDashboards)
